import { Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

import type { ChartProps } from '../../../types/charts.js';
import PieChartLegend from './PieChartLegend.jsx';
import PieLabel from './PieLabel.jsx';
import PieTooltip from './PieTooltip.jsx';
import { usePieChartData } from './usePieChart.jsx';

type PieLabelProps = {
  x: number;
  y: number;
  cx: number;
  cy: number;
  value?: number;
  percent?: number;
};

const CustomPieChart = ({
  x,
  y,
  dataframe,
  isMobile,
  isExport = false,
  isAgentic = false,
}: ChartProps) => {
  const isCompactView = isMobile || isAgentic;
  const { chart, isTwoLevel } = usePieChartData({
    x,
    y,
    dataframe,
  });
  const { nameKey, dataKey, chartData } = chart;

  const renderLabel = (labelData: PieLabelProps) => {
    return <PieLabel labelData={labelData} />;
  };

  const Chart = (
    <PieChart width={700} height={isTwoLevel ? 400 : 250}>
      {!isExport && (
        <Tooltip
          isAnimationActive={false}
          wrapperStyle={{
            outline: 'none',
            zIndex: 5000, // Equals to z-tooltip
          }}
          content={PieTooltip}
        />
      )}

      <Pie
        width={700}
        height={isTwoLevel ? 400 : 250}
        data={chartData}
        dataKey={dataKey}
        nameKey={nameKey}
        cx="50%"
        cy={isTwoLevel ? '50%' : '100'}
        innerRadius={isTwoLevel ? 0 : 80}
        outerRadius={100}
        isAnimationActive={false}
      />

      {isTwoLevel && (
        <Pie
          data={chartData.flatMap((item) => item.children)}
          dataKey={dataKey}
          nameKey={x}
          cx="50%"
          cy="50%"
          innerRadius={90}
          outerRadius={120}
          label={(labelData) => renderLabel(labelData)}
          isAnimationActive={false}
        />
      )}
    </PieChart>
  );

  if (isCompactView) {
    return (
      <>
        <ResponsiveContainer width="99%" height={isTwoLevel ? 400 : 250}>
          {Chart}
        </ResponsiveContainer>
        <PieChartLegend isMobile={isMobile} chartData={chartData} />
      </>
    );
  }

  return (
    <div className="mb-2 flex flex-col items-center justify-center">
      {Chart}
      <PieChartLegend isMobile={isMobile} chartData={chartData} />
    </div>
  );
};

export default CustomPieChart;
